var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"id":"header"}}),_c('div',{staticClass:"page-content"},[_c('transition',{attrs:{"name":"blur"}},[_c('router-view')],1)],1),_c('Footer'),_c('CookieManager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }